<template>
  <b-container> </b-container>
</template>
  
<script>
export default {
  name: "LeafletMarker",
  props: {
    latitude: Number,
    longitude: Number,
    markerStyle: String,
  },
  components: {},
  mixins: [],
  data() {
    return {
      mapMarker: null,
    };
  },
  inject: ["getMap"],
  methods: {
    createIcon(markerStyle) {
      // console.log("LeafletMarker.createIcon()");
      if (markerStyle && markerStyle == "secondary") {
        return L.icon({
          iconUrl:
            "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
          shadowUrl:
            "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
          iconSize: [12.5, 20.5],
          iconAnchor: [8, 20.5],
          popupAnchor: [1, -34],
          shadowSize: [20.5, 20.5],
        });
      }      
      if (markerStyle && markerStyle == "invisible") {
          return L.divIcon({
            className: "leaflet-marker-invisible",
            html: `<div class="marker-pin-label"></div>`,
            iconSize: [21, 21],
          });
      }
      return new L.Icon.Default();
    },
    destroy() {
      //   try {
      //     if (infobox) {
      //       let map = this.getMap();
      //       if (map) {
      //         infobox.setMap(null);
      //       }
      //     }
      //   } finally {
      //     this.setItem(null);
      //   }
    },
    setIcon() {
      let icon = this.createIcon(this.markerStyle);
      this.mapMarker.setIcon(icon);
    },
    render() {
      let map = this.getMap();
      this.mapMarker = L.marker([this.latitude, this.longitude], {
        draggable: false,
        // icon: L.Icon.Default,
        //icon: this.createIcon(this.markerStyle),
      })
        .on("click", (e) => {
          this.$emit('onClick', e);
          //console.log("hi. you clicked the marker at " + e.latlng);
        })
        .addTo(map);
      // this.mapMarker.setIcon(L.Icon.Default);
      this.setIcon();

      // if (this.markerStyle && this.markerStyle == "secondary") {
      //   this.mapMarker = L.marker([this.latitude, this.longitude], {
      //     draggable: false,
      //     // icon: L.divIcon({
      //     //   className: "marker-pin-circle-normal",
      //     //   html: `<div class="marker-pin-label"></div>`,
      //     //   iconSize: [21, 21],
      //     // }),
      //     // icon: L.Icon({
      //     //   iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
      //     //   shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      //     //   iconSize: [25, 41],
      //     //   iconAnchor: [12, 41],
      //     //   popupAnchor: [1, -34],
      //     //   shadowSize: [41, 41]
      //     // }),
      //     icon: L.icon({
      //       iconUrl:
      //         "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
      //       shadowUrl:
      //         "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
      //       iconSize: [12.5, 20.5],
      //       iconAnchor: [8, 20.5],
      //       popupAnchor: [1, -34],
      //       shadowSize: [20.5, 20.5],
      //     }),
      //   }).addTo(map);
      //   console.log(this.mapMarker);
      // } else {
      //   this.mapMarker = L.marker([this.latitude, this.longitude]).addTo(map);
      // }

      // this.mapMarker = L.marker([this.latitude, this.longitude])
      //   .addTo(map)
      //   .bindPopup("<b>Hello world!</b><br />I am a popup.")
      //   .openPopup();
    },
  },
  beforeDestroy() {
    this.destroy();
  },
  mounted() {
    this.render();
  },
  watch: {
    latitude() {
      this.mapMarker.setLatLng([this.latitude, this.longitude]);
    },
    longitude() {
      this.mapMarker.setLatLng([this.latitude, this.longitude]);
    },
    markerStyle() {
      this.setIcon();
    },
  },
};
</script>
